
import apiClient from "../../axios/apiClient";
import { getDateTimeMysqlGivenFormatYmdhi } from "../../util/generalUtills";

export const getCurrentBookingList =
  (token, limit = 10, page = 1, search = "", sort = "desc", status) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_CURRENT_JOB_LIST_PENDING" });

        const response = await apiClient.get(
          `/api/V1/booking/current`,
          {
            params: {
              limit: limit,
              page: page,
              search: search,
              sort: sort,
              status: status,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_CURRENT_JOB_LIST_FULFILLED",
          payload: response.data?.data,
          count: response.data?.count,
          permissions: response.data?.permissions,
        });
      } catch (error) {
        dispatch({
          type: "GET_CURRENT_JOB_LIST_REJECTED",
          payload: error.response,
        });
      }
    };


export const getOtpBookingList =
  (token, limit = 10, page = 1, search = "", sort = "desc", status) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_CURRENT_JOB_LIST_PENDING" });

        const response = await apiClient.get(
          `/api/v1/booking/otp`,
          {
            params: {
              limit: limit,
              page: page,
              search: search,
              sort: sort,
              status: status,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_CURRENT_JOB_LIST_FULFILLED",
          payload: response.data?.data,
          count: response.data?.count,
          permissions: response.data?.permissions,
        });
      } catch (error) {
        dispatch({
          type: "GET_CURRENT_JOB_LIST_REJECTED",
          payload: error.response,
        });
      }
    };

export const getSlipAllotmentList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_SLIP_ALLOTMENT_LIST_PENDING" });

        const response = await apiClient.get(
          `/api/v1/slip-generation`,
          {
            params: {
              limit: limit,
              page: page,
              search: search,
              sort: sort,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_SLIP_ALLOTMENT_LIST_FULFILLED",
          payload: response.data?.data,
          count: response.data?.count,
          permissions: response.data?.permissions,
        });
      } catch (error) {
        dispatch({
          type: "GET_SLIP_ALLOTMENT_LIST_REJECTED",
          payload: error.response,
        });
      }
    };

export const getSlipAllotmentListById =
  (token, id) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_SLIP_ALLOTMENT_BY_ID_LIST_PENDING" });

        const response = await apiClient.get(
          `/api/v1/slip-generation/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_SLIP_ALLOTMENT_BY_ID_LIST_FULFILLED",
          payload: response.data?.data,
          count: response.data?.count,
        });
      } catch (error) {
        dispatch({
          type: "GET_SLIP_ALLOTMENT_BY_ID_LIST_REJECTED",
          payload: error.response,
        });
      }
    };


export const getassignBookingList =
  (token, bookingid, limit = 10, page = 1, search = "", sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_ASSIGN_BOOKING_PENDING" });

        const response = await apiClient.get(
          `/api/admin/v1/Assign-Booking/${bookingid}`,
          {
            params: {
              limit: limit,
              page: page,
              search: search,
              sort: sort,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_ASSIGN_BOOKING_FULFILLED",
          payload: response.data,
          count: response.data?.count,
          permissions: response.data?.permissions,
        });
      } catch (error) {
        dispatch({
          type: "GET_ASSIGN_BOOKING_REJECTED",
          payload: error.response,
        });
      }
    };

export const saveBookingData = (token, data) => async (dispatch) => {
  try {
    dispatch({ type: "ADD_BOOKING_PENDING" });
    data.booking_date = getDateTimeMysqlGivenFormatYmdhi(data.booking_date)
    const response = await apiClient.post(
      `/api/admin/v1/Save-Booking`,
      data, // Data payload should be the second argument
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_BOOKING_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "ADD_BOOKING_REJECTED", payload: error.response });
  }
};

export const generateSlipData = (token, data) => async (dispatch) => {
  try {
    dispatch({ type: "GENERATE_SLIP_PENDING" });
    data.booking_date = getDateTimeMysqlGivenFormatYmdhi(data.booking_date)
    const response = await apiClient.post(
      `/api/v1/slip-generation/generate-slip`,
      data, // Data payload should be the second argument
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "GENERATE_SLIP_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "GENERATE_SLIP_REJECTED", payload: error.response });
  }
};

export const assignBookingData = (token, bookingId, vehicleId) => async (dispatch) => {
  try {
    const param = {
      "booking_id": bookingId,
      "vehicle_id": vehicleId
    }

    dispatch({ type: "ADD_ASSIGN_BOOKING_PENDING" });
    const response = await apiClient.post(
      `/api/admin/v1/Assign-Vehicle`,
      param, // Data payload should be the second argument
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_ASSIGN_BOOKING_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "ADD_ASSIGN_BOOKING_REJECTED", payload: error.response });
  }
};

export const cancelBookingData = (token, bookingId, cancelId) => async (dispatch) => {
  try {
    const param = {
      "booking_id": bookingId,
      "reason": cancelId
    }

    dispatch({ type: "ADD_CANCEL_BOOKING_PENDING" });
    const response = await apiClient.post(
      `/api/admin/v1/Cancel-Booking`,
      param, // Data payload should be the second argument
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_CANCEL_BOOKING_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "ADD_CANCEL_BOOKING_REJECTED", payload: error.response });
  }
};


export const getCancelBookingList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_CANCEL_LIST_PENDING" });

        const response = await apiClient.get(
          `/api/v1/booking/cancel`,
          {
            params: {
              limit: limit,
              page: page,
              search: search,
              sort: sort,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_CANCEL_LIST_FULFILLED",
          payload: response.data?.data,
          count: response.data?.count,
          permissions: response.data?.permissions,
        });
      } catch (error) {
        dispatch({
          type: "GET_CANCEL_LIST_REJECTED",
          payload: error.response,
        });
      }
    };

export const getPendingBookingList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_PENDING_LIST_PENDING" });

        const response = await apiClient.get(
          `/api/v1/booking/verification-pending`,
          {
            params: {
              limit: limit,
              page: page,
              search: search,
              sort: sort,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_PENDING_LIST_FULFILLED",
          payload: response.data?.data,
          count: response.data?.count,
          permissions: response.data?.permissions,
        });
      } catch (error) {
        dispatch({
          type: "GET_PENDING_LIST_REJECTED",
          payload: error.response,
        });
      }
    };


export const getCompleteBookingList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_COMPLETE_LIST_PENDING" });

        const response = await apiClient.get(
          `/api/v1/booking/partial-complete`,
          {
            params: {
              limit: limit,
              page: page,
              search: search,
              sort: sort,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_COMPLETE_LIST_FULFILLED",
          payload: response.data?.data,
          count: response.data?.count,
          permissions: response.data?.permissions,
        });
      } catch (error) {
        dispatch({
          type: "GET_COMPLETE_LIST_REJECTED",
          payload: error.response,
        });
      }
    };

export const getTrackDetailsBookingList =
  (token, bookingid, limit = 10, page = 1, search = "", sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_TRACK_BOOKING_PENDING" });

        const response = await apiClient.get(
          `/api/v1/booking/${bookingid}`,
          {
            params: {
              limit: limit,
              page: page,
              search: search,
              sort: sort,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_TRACK_BOOKING_FULFILLED",
          payload: response.data,
          count: response.data?.count,
          permissions: response.data?.permissions,
        });
      } catch (error) {
        dispatch({
          type: "GET_TRACK_BOOKING_REJECTED",
          payload: error.response,
        });
      }
    };

    export const getOpeningValveList =
  (token,  limit = 10, page = 1, search = "", sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_OPENING_VALVE_LIST_PENDING" });

        const response = await apiClient.get(
          `/api/v1/booking/opening-valve`,
          {
            params: {
              limit: limit,
              page: page,
              search: search,
              sort: sort,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_OPENING_VALVE_LIST_FULFILLED",
          payload: response.data.data,
          count: response.data?.count,
          permissions: response.data?.permissions,
        });
      } catch (error) {
        dispatch({
          type: "GET_OPENING_VALVE_LIST_REJECTED",
          payload: error.response,
        });
      }
    };